export type CreditType = {
  enabled: boolean;
  id: string;
  name: CreditTypeName;
  categories: CreditCategory[];
};

type CreditCategory = {
  id: string;
  name: string;
  code: string;
};

export enum CreditTypeName {
  MULTIUSE = 'MULTIUSE_CREDIT',
  MOBILITY = 'MOBILITY_CREDIT',
  LOCAL_CREDIT = 'LOCAL_CREDIT',
}
